import { Button, styled } from 'src/modules';

export const AddDocumentButton = styled(Button)`
  margin-top: 32px;
`;
